"use strict";

import {form as className} from "./SkipLinkTemplate";

export default  {"template": "FieldSetTemplate", className}



/** WEBPACK FOOTER **
 ** ./src/templates/SkipLinkTemplate.js
 **/